import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { messages } from '../../constants/Collection';
import { FilterNavTypes } from '../../constants/FilterTypeNav';
import { GridConstants } from '../../constants/Grid';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import * as Utils from '../../utils';

import CatalogGridItem from './CatalogGridItem';

/**
 * AlbumGridItem is for rendering T3 album grid items.
 *
 * See CatalogGridItem and lib/GridItem for additional available props.
 */
class AlbumGridItem extends React.Component {
  static propTypes = {
    collectedTrackCount: PropTypes.number,
    currentFilter: PropTypes.string,
    id: PropTypes.string,
    intl: PropTypes.object,
    isPaused: PropTypes.bool,
    isPlayingCurrently: PropTypes.bool,
    itemOnclickUrl: PropTypes.string,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    pandoraType: PropTypes.string,
    secondText: PropTypes.string,
    sourceCardMenuItems: PropTypes.array,
    trackCount: PropTypes.number,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.ALBUM,
  };

  render() {
    let thirdText;
    if (this.props.collectedTrackCount) {
      thirdText = this.props.intl.formatMessage(messages.albumPartiallyCollectedThirdText, {
        num: this.props.collectedTrackCount,
      });
    } else {
      if (this.props.currentFilter === FilterNavTypes.ALL) {
        // Show "Album - # songs" only for the "All" filter
        thirdText = this.props.intl.formatMessage(messages.albumMixedFullyCollectedThirdText, {
          num: this.props.trackCount,
        });
      } else {
        thirdText = this.props.intl.formatMessage(messages.albumFullyCollectedThirdText, {
          num: this.props.trackCount,
        });
      }
    }
    return <CatalogGridItem thirdText={thirdText} {...this.props} />;
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const id = ownProps.id;
  const details = getAnnotationsById(state, id);
  props.blankItem = !details;
  if (details && id) {
    props.currentFilter = getInDomain('collection.utils.getCurrentFilter', noop)(state);
    props.sourceCardMenuItems = getSourceCardMenuItems({
      pandoraId: id,
      pandoraType: PandoraTypes.ALBUM,
      shareParentSource: {
        shareParentSourceId: id,
        shareParentSourceType: PandoraTypes.ALBUM,
      },
      state,
    });
    props.mainText = details.get('name');
    const backstageUrl = details.get('shareableUrlPath');
    props.mainTextUrl = backstageUrl;
    props.itemOnclickUrl = backstageUrl;
    props.secondText = details.get('artistName');
    props.trackCount = details.get('trackCount');
    const artist = getAnnotationsById(state, details.get('artistId'));
    if (artist) {
      props.secondTextUrl = artist.get('shareableUrlPath');
    }
    const playingSourceId = ownProps.collectedTrackCount
      ? Utils.SourceType.getCollectedAlbumTracksId(id)
      : id;
    props.isPlayingCurrently = getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      playingSourceId,
    );
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.isExplicit = getInDomain('catalog.utils.isExplicit')(details);
    props.isClean = getInDomain('catalog.utils.isClean')(details);
    props.dominantColor = getDominantColor(details);
  }
  return props;
}

const enhance = compose(
  // We use injectIntl here because there was some inexplicable performance issues when using <FormattedMessage> directly in the props
  injectIntl,
  connect(mapStateToProps),
);

export default enhance(AlbumGridItem);
